import { SelectOption, SelectOptionGroup } from "@amzn/meridian";
import React from "react";
import { INADEQUATE_INFORMATION, OTHER } from "src/constants";
import { ReviewStatus } from "src/store/modelLifeCycleGroundTruthSlice";

export const getInadequateSelection = (parentFieldValue?: string) => {
  let value = INADEQUATE_INFORMATION;
  if (parentFieldValue) {
    value = `${parentFieldValue}---${INADEQUATE_INFORMATION}`;
  }
  return (
    <SelectOptionGroup label={"Answer not exist in the description"}>
      <SelectOption label={INADEQUATE_INFORMATION} value={value} />
    </SelectOptionGroup>
  );
};

export const otherSelection = (
  parentFieldValue?: string,
  fieldName?: string,
  reviewStatus?: ReviewStatus,
) => {
  // For any unreviewed case, risk hazard fields shouldn't show "Other" option
  if (reviewStatus === ReviewStatus.UNREVIEWED && fieldName === "risk_hazard") {
    return null;
  }

  let value = OTHER;
  if (parentFieldValue) {
    value = `${parentFieldValue}---${OTHER}`;
  }
  return (
    <SelectOptionGroup label={"Not available in option list"}>
      <SelectOption label={OTHER} value={value} />
    </SelectOptionGroup>
  );
};
